import React from "react";
import SectionHeader from "@/components/shared/SectionHeader";
import { EISG_IMG } from "@/lib/data";

const CAPACITIES = [
  "Comprendre les enjeux réels de l'IA",
  "Gouverner les risques, l'éthique et la conformité",
  "Piloter la transformation digitale",
  "Aligner les équipes et les métiers",
  "Transformer les données en décisions",
  "Créer de la valeur durable pour leurs organisations",
];

const EISGAbout = () => (
  <div>
    <section className="relative py-32 lg:py-40 bg-[#0A192F] text-white grain overflow-hidden">
      <div className="absolute inset-0 opacity-25">
        <img src={EISG_IMG.executives} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A192F] via-[#0A192F]/90 to-transparent" />
      </div>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 relative">
        <div className="overline text-[#D4AF37] mb-6">— À propos</div>
        <h1 className="font-eisg text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.02] max-w-4xl">
          L'exécutif au cœur de la <span className="text-[#D4AF37] italic">transformation.</span>
        </h1>
      </div>
    </section>

    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-16">
        <div className="lg:col-span-5">
          <SectionHeader number="— 01" eyebrow="Notre mission" title="Développer les leaders qui transformeront l'Afrique." titleFont="eisg" />
        </div>
        <div className="lg:col-span-7 text-[#0A192F]/80 text-lg leading-relaxed space-y-5">
          <p>
            EISG est l'Institut Exécutif de Stratégie et de Gouvernance de BridgeDatum. Il développe les capacités des leaders africains à anticiper, décider, gouverner et exécuter dans un monde transformé par l'intelligence artificielle.
          </p>
          <p>
            EISG forme des dirigeants capables de transformer la complexité technologique en avantage institutionnel durable.
          </p>
        </div>
      </div>
    </section>

    <section className="py-24 lg:py-32 bg-[#FAFAFA]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <SectionHeader number="— 02" eyebrow="Capacités développées" title="EISG forme des dirigeants capables de :" titleFont="eisg" />
        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-px bg-[#0A192F]/10">
          {CAPACITIES.map((c, i) => (
            <div key={c} className="bg-white p-8 lift-card flex items-start gap-5">
              <div className="font-eisg text-4xl text-[#D4AF37] leading-none">{String(i + 1).padStart(2, "0")}</div>
              <p className="font-bd text-lg text-[#0A192F] leading-snug pt-1">{c}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="py-28 lg:py-36 bg-[#0A192F] text-white grain">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="overline text-[#D4AF37] mb-8">— Manifeste</div>
        <p className="font-eisg text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.1] max-w-5xl">
          "L'intelligence artificielle ne se délègue plus. <span className="text-[#D4AF37] italic">Elle se gouverne.</span>"
        </p>
      </div>
    </section>
  </div>
);

export default EISGAbout;
